import { Injectable } from '@angular/core';
import { AlertController } from "@ionic/angular";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private alertController: AlertController) { }

  async presentAlert(message: string, header?: string, subHeader?: string, ) {
    const alert = await this.alertController.create({
      cssClass: '',
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['OK'],
      backdropDismiss: false
    });
    await alert.present();
  }

  async showAlertConfirmation(header: string, message: string, callback, id?: number, okText?: string, cancelText?: string) {
      const alert = await this.alertController.create({
        header: header,
        message: message,
        backdropDismiss: false,
        keyboardClose: true,
        buttons: [
          {
            text: cancelText,
          },
          {
            text: okText,
            role: 'cancel',
            handler: () => {
              callback.deletePhoto(id);
            }
          }
        ]
      });
      await alert.present();

  }


}
